<div class="vc-card" role="dialog" [attr.aria-label]="headerName">
  <header class="vc-header">
    <img class="vc-boat-icon" src="/assets/home/profile/boaticon.svg" alt="" />
    <span class="vc-title">{{ headerName }}</span>
    <button type="button" class="vc-close" (click)="onClose()" aria-label="Close">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  </header>

  <div class="vc-body">
    <div *ngIf="isLoading && !quick" class="vc-loading" role="status" aria-label="Loading">
      <span class="vc-spinner"></span>
    </div>

    <p *ngIf="hasError && !quick" class="vc-error">Failed to load observation</p>

    <ng-container *ngIf="view as v">
      <div *ngIf="v.headline" class="vc-headline">{{ v.headline }}</div>

      <div *ngIf="v.waterLine" class="vc-water" [class.vc-after-headline]="!!v.headline">{{ v.waterLine }}</div>

      <div *ngIf="v.position" class="vc-position">{{ v.position }}</div>

      <button *ngIf="v.showParticipants" type="button" class="vc-crew" (click)="onParticipantsClick()">
        <span class="vc-avatars" [style.width.px]="avatarStripWidth">
          <span *ngIf="overflowCount > 0" class="vc-avatar vc-avatar-overflow"
            [style.left.px]="visibleParticipants.length * 16">+{{ overflowCount }}</span>
          <!-- Painted last-to-first so the first participant ends up on top, as in Flutter -->
          <span *ngFor="let p of visibleParticipants; let i = index" class="vc-avatar"
            [style.left.px]="i * 16" [style.z-index]="10 - i">
            <img *ngIf="p.imageUrl" [src]="p.imageUrl" alt="" (error)="p.imageUrl = null" />
            <span *ngIf="!p.imageUrl" class="vc-initials-sm">{{ initials(p.name || 'Participant') }}</span>
          </span>
        </span>
        <span class="vc-crew-label">Participants</span>
      </button>

      <ng-container *ngIf="v.hasIdentity">
        <hr *ngIf="v.hasReadingsAbove" class="vc-divider" />

        <div class="vc-identity-row">
          <div class="vc-owner-slot">
            <ng-container *ngIf="ownerDisplayName; else tsOnly">
              <button *ngIf="canOpenProfile; else ownerStatic" type="button" class="vc-owner vc-owner-link"
                (click)="onOwnerClick()">
                <ng-container *ngTemplateOutlet="ownerBody"></ng-container>
              </button>
              <ng-template #ownerStatic>
                <div class="vc-owner"><ng-container *ngTemplateOutlet="ownerBody"></ng-container></div>
              </ng-template>
            </ng-container>
            <ng-template #tsOnly>
              <span *ngIf="v.tsLabel" class="vc-ts">{{ v.tsLabel }}</span>
            </ng-template>
            <ng-template #ownerBody>
              <span class="vc-owner-avatar">
                <img *ngIf="ownerDisplayImage" [src]="ownerDisplayImage" alt="" (error)="ownerDisplayImage = null" />
                <span *ngIf="!ownerDisplayImage" class="vc-initials">{{ initials(ownerDisplayName) }}</span>
              </span>
              <span class="vc-owner-text">
                <span class="vc-owner-name" [class.vc-owner-name-link]="canOpenProfile">{{ ownerDisplayName }}</span>
                <span *ngIf="v.tsLabel" class="vc-ts">{{ v.tsLabel }}</span>
              </span>
            </ng-template>
          </div>

          <button *ngIf="v.showChat" type="button" class="vc-chat" (click)="onChatClick()" aria-label="Chat">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z" />
            </svg>
          </button>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
